import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Container, Card, Typography, Box, Button, Fab, Grid, } from "@mui/material";
import Divider from '@mui/material/Divider';
import AddIcon from '@mui/icons-material/Add';
import CheckIcon from '@mui/icons-material/Check';
import Avatar from '@mui/material/Avatar';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import PropertyIcon from '../../../public/assets/PropertyIcon.svg';
import originMap from '../../../public/assets/OriginMap.svg';
import destinationMap from '../../../public/assets/destinationMap.svg';
import Rating from '@mui/material/Rating';
import PhoneIcon from '@mui/icons-material/Phone';
import { styled } from '@mui/system';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import toast from 'react-hot-toast';
import LeadService from '../../core/services/leadsService';
import LinearProgress from '@mui/material/LinearProgress';
import ScrollAnimation from 'react-animate-on-scroll';
import { GlobalStyles } from '@mui/system';
import { ThemeProvider } from '@mui/material/styles';
import { useTheme } from '@mui/material/styles';
// google map
import {
    GoogleMap,
    DirectionsService,
    DirectionsRenderer,
    useLoadScript,
    Marker,
    OverlayView,
} from '@react-google-maps/api';
const imageStyle = {
    width: '60px',
    height: '60px',
};
const Stack = styled('div')({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '20px',
});

const FabContainer = styled('div')({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '400px',
    position: 'relative',
});

const Line = styled('div')({
    position: 'absolute',
    top: '24px',
    left: '56px',
    width: '208px',
    height: '2px',
    backgroundColor: '#5379BD',
});
const Line2 = styled('div')({
    position: 'absolute',
    top: '24px',
    left: '208px',
    width: '188px',
    height: '2px',
    backgroundColor: '#B4B4B4',
});
const ButtonContainer = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
});

const ButtonLabel = styled(Typography)({
    marginTop: '8px',
});

const AdminJobDetails = () => {
    let { id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const theme = useTheme();
    const { job_type, user_type, customerId } = location.state || {};
    const [value, setValue] = React.useState(3);
    const [directions, setDirections] = useState(null);
    const [directions2, setDirections2] = useState(null);
    const [duration, setDuration] = useState(null);
    const [distance, setDistance] = useState(null);
    const [distance2, setDistance2] = useState(null);
    const [duration2, setDuration2] = useState(null);
    const [jobDetail, setJobDetail] = useState(null);
    const [jobData, setJobData] = useState(null);
    const [customerData, setCustomerData] = useState(null);
    const [assigntoData, setAssigntoData] = useState(null);
    const [isLoadingDetails, setIsLoadingDetails] = React.useState(false);
    const [phoneNumber1, setPhoneNumber1] = useState('');
    const [phoneNumber2, setPhoneNumber2] = useState('');
    const [origin, setOrigin] = useState();  //Customer
    const [origin2, setOrigin2] = useState();  //Agent or AssignTo
    const [destination, setDestination] = useState(); //Lead
    const [loading, setLoading] = useState(false);
    const [angle, setAngle] = useState(0);
    const [angle2, setAngle2] = useState(0);

    const imageStyle = {
        width: '80px',
        height: '70px',
        marginTop: '-42px',
        transform: `rotate(${angle}deg)`
    };
    const imageStyle2 = {
        width: '80px',
        height: '56px',
        marginTop: '-42px',
        transform: `rotate(${angle2}deg)`
    };

    useEffect(() => {
        if (customerData) {
            setAngle(customerData?.angle);
        }
    }, [customerData]);

    useEffect(() => {
        if (assigntoData) {
            setAngle2(assigntoData?.angle);
        }
    }, [assigntoData]);

    const handleButtonViewNumber1 = () => {
        if (customerData?.phone === null || customerData?.phone === '' || customerData?.phone === undefined) {
            return toast.error('Phone number is not available.')
        } else {
            setPhoneNumber1(customerData?.phone);
        }

    };

    const handleButtonViewNumber2 = () => {
        if (assigntoData?.phone === null || assigntoData?.phone === '' || assigntoData?.phone === undefined) {
            return toast?.error('Phone number is not available.')
        }
        else {
            setPhoneNumber2(assigntoData?.phone);
        }
    };

    const HandleBackNavigate = (user_type, customerId) => {
        clearInterval(intervalRef.current);
        intervalRef.current = null;

        if (user_type === 'customer') {
            navigate(`/customers-details/${customerId}`);
        } else {
            navigate('/jobs');
        }


    }

    const mapContainerStyle = {
        width: 'auto',
        height: '446px',
        marginTop: '20px',
        marginBottom: '20px',
        borderRadius: '21px'
    };
    const { isLoaded, loadError } = useLoadScript({
        googleMapsApiKey: 'AIzaSyCkMAzfTYAjsRE0zZoITa3ktRqd00zLksU',
        libraries: ['directions'],
    });

    const prevOriginRef = useRef();
    const prevOrigin2Ref = useRef();
    const prevDestinationRef = useRef();
    const intervalRef = useRef(null);
    const isFirstCallRef = useRef(true);
    const fetchJobDetails = useCallback(async (isFirstCall) => {
        if (isFirstCall) {
            setLoading(true);
        }
        try {

            const res = await LeadService.jobDetail(id, job_type);
            if (res.data.success === true) {
                const details = res.data.jobDetails;
                setJobDetail(details);
                setJobData(details?.job);
                setCustomerData(details?.customer);
                setAssigntoData(details?.assignto);

            } else if (res.data.success === false) {
                toast.error('Job detail are null')

            }
        } catch (error) {
            toast.error(error.message);
        } finally {
            setLoading(false);
        }
    }, [id, job_type]);

    useEffect(() => {
        fetchJobDetails(isFirstCallRef.current);
        isFirstCallRef.current = false;

        intervalRef.current = setInterval(fetchJobDetails, 10000);
        return () => clearInterval(intervalRef.current);
    }, [fetchJobDetails]);

    useEffect(() => {
        if (customerData && jobData) {
            let newOrigin = {
                lat: parseFloat(customerData?.latitude),
                lng: parseFloat(customerData?.longitude),
            };

            // Check if customer latitude or longitude is missing
            if (!newOrigin.lat || !newOrigin.lng) {
                // If missing, use destination latitude and longitude as customer location
                newOrigin = {
                    lat: destination?.lat,
                    lng: destination?.lng
                };
            }

            // Update origin if it has changed
            if (
                !prevOriginRef.current ||
                newOrigin.lat !== prevOriginRef.current.lat ||
                newOrigin.lng !== prevOriginRef.current.lng
            ) {
                setOrigin(newOrigin);
                setAngle(customerData.angle);
                prevOriginRef.current = newOrigin;
            }
        }
    }, [customerData, jobData, destination]);

    useEffect(() => {
        if (assigntoData) {
            const newOrigin2 = {
                lat: parseFloat(assigntoData.latitude),
                lng: parseFloat(assigntoData.longitude),
            };
            if (!prevOrigin2Ref.current || newOrigin2.lat !== prevOrigin2Ref.current.lat || newOrigin2.lng !== prevOrigin2Ref.current.lng) {
                setOrigin2(newOrigin2);
                setAngle2(assigntoData.angle);
                prevOrigin2Ref.current = newOrigin2;
            }
        }
    }, [assigntoData]);

    useEffect(() => {
        if (jobData) {
            // Check if meeting latitude and longitude are available
            let latitude = jobData?.meeting_latitude;
            let longitude = jobData?.meeting_longitude;

            // If not available, use buyer latitude and longitude
            if (!latitude || !longitude) {
                latitude = jobData?.buyer_latitude;
                longitude = jobData?.buyer_longitude;
            }

            // Create the new destination object
            const newDestination = {
                lat: parseFloat(latitude),
                lng: parseFloat(longitude),
            };

            // Update destination only if it has changed
            if (
                !prevDestinationRef.current ||
                newDestination.lat !== prevDestinationRef.current.lat ||
                newDestination.lng !== prevDestinationRef.current.lng
            ) {
                setDestination(newDestination);
                prevDestinationRef.current = newDestination;
            }
        }
    }, [jobData]);

    useEffect(() => {
        if (isLoaded && origin && destination) {

            const directionsService = new window.google.maps.DirectionsService();
            const request = {
                origin: origin,
                destination: destination,
                travelMode: 'DRIVING',
            };
            directionsService.route(request, (response, status) => {
                if (status === 'OK') {
                    setDuration(response.routes[0].legs[0].duration.text);
                    setDistance(response.routes[0].legs[0].distance.text);
                    setDirections(response);
                } else {
                    console.error('Error fetching directions:', status);
                }
            });
        }
    }, [isLoaded, origin, destination]);

    useEffect(() => {
        if (isLoaded && origin2 && destination) {
            const directionsService = new window.google.maps.DirectionsService();
            const request2 = {
                origin: origin2,
                destination: destination,
                travelMode: 'DRIVING',
            };
            directionsService.route(request2, (response, status) => {
                if (status === 'OK') {
                    setDuration2(response.routes[0].legs[0].duration.text);
                    setDistance2(response.routes[0].legs[0].distance.text);
                    setDirections2(response);
                } else {
                    console.error('Error fetching directions:', status);
                }
            });
        }
    }, [isLoaded, origin2, destination]);


    const parseDistance = (distanceString) => {
        const parsedDistance = parseFloat(distanceString.replace(/[^0-9.]/g, ''));
        if (distanceString.includes('km')) {
            return parsedDistance * 1000; // Convert kilometers to meters
        } else if (distanceString.includes('mi')) {
            return parsedDistance * 1609.34; // Convert miles to meters
        } else {
            return parsedDistance; // Already in meters
        }
    };


    return isLoaded ? (
        <>
            <div style={{ marginBottom: '15px' }}> {loading && <LinearProgress />}</div>
            <Box>
                <Button onClick={() => HandleBackNavigate(user_type, customerId)}
                    sx={{ background: '#efefef', padding: '6px', '&:hover': { background: '#cecaca' }, }}>
                    <ArrowBackIosIcon style={{ color: '#8f7f7f', marginLeft: '6px' }} />
                </Button>

            </Box>
            <ThemeProvider theme={theme}>
                <GlobalStyles
                    styles={{
                        '::-webkit-scrollbar': {
                            width: '14px', // Set the desired width for the scrollbar
                        },
                        '::-webkit-scrollbar-thumb': {
                            backgroundColor: '#c1c1c1', // Set the color for the scrollbar thumb
                            borderRadius: '10px', // Set the border radius for a rounded effect
                        },
                    }}
                />
                <Box>
                    {!loading && jobDetail ? (
                        <Box>
                            <ScrollAnimation animateIn='fadeIn'>
                                <Box style={{ marginTop: '20px', position: 'relative', borderRadius: '22px', boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px' }}>
                                    {jobDetail === null ? null : (
                                        <div>
                                            <GoogleMap
                                                center={origin || origin2 || destination}
                                                zoom={10}
                                                mapContainerStyle={mapContainerStyle}
                                                options={{
                                                    disableDefaultUI: false,
                                                    clickableIcons: false,
                                                    scrollwheel: false,
                                                    mapTypeControl: false,
                                                    fullscreenControl: false,
                                                    streetViewControl: false,
                                                    minZoom: 1,
                                                }}
                                            >
                                                {directions && <DirectionsRenderer directions={directions} options={{ suppressMarkers: true }} />}
                                                {directions2 && <DirectionsRenderer directions={directions2} options={{ suppressMarkers: true }} />}
                                                {origin?.lat && (
                                                    <OverlayView position={origin} mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}>
                                                        <div style={{
                                                            position: 'absolute',
                                                            top: '10px',
                                                            left: '55%',
                                                            transform: 'translateX(-50%)',
                                                            zIndex: 10,
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            borderRadius: '4px',
                                                            padding: '5px',
                                                        }}>
                                                            <img src={originMap} style={imageStyle} alt="Origin" />
                                                        </div>
                                                    </OverlayView>
                                                )}
                                                {origin2?.lat && (
                                                    <OverlayView position={origin2} mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}>
                                                        <div style={{
                                                            position: 'absolute',
                                                            top: '10px',
                                                            left: '55%',
                                                            transform: 'translateX(-50%)',
                                                            zIndex: 10,
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            borderRadius: '4px',
                                                            padding: '5px',
                                                        }}>
                                                            <img src={destinationMap} style={imageStyle2} alt="Origin" />
                                                        </div>
                                                    </OverlayView>
                                                )}
                                                {destination?.lat && (
                                                    <OverlayView position={destination} mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}>
                                                        <div style={{
                                                            position: 'absolute',
                                                            top: '10px',
                                                            left: '55%',
                                                            transform: 'translateX(-50%)',
                                                            zIndex: 10,
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            borderRadius: '4px',
                                                            padding: '5px',
                                                        }}>
                                                            <img src={PropertyIcon} style={{ width: '27px', height: '27px', marginTop: '-42px' }} />
                                                        </div>
                                                    </OverlayView>
                                                )}
                                            </GoogleMap>
                                        </div>
                                    )}

                                </Box>
                                <Card style={{ padding: '20px', marginTop: '10px', borderRadius: '22px', boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px' }}>
                                    <Typography style={{ fontSize: '28px', fontWeight: '700' }}>Customer Details</Typography>
                                    <Divider />


                                    <Grid container sx={{mt: '20px', p: '10px', backgroundColor: '#f3f3f3', borderRadius: '8px'}}>
                                        <Grid item md={3} sm={3} xs={6}>
                                        <Typography style={{ fontSize: '19px', fontWeight: '600', color: '#378b37' }}>Customer</Typography>
                                        <Typography style={{ fontSize: '19px', }}>{customerData?.name}{' '}{customerData?.last_name}</Typography>
                                        </Grid>
                                        <Grid item md={3} sm={3} xs={6}>
                                        <Typography style={{ fontSize: '19px', fontWeight: '600' }}>Duration</Typography>
                                        <Typography style={{ fontSize: '17px' }}>{duration}</Typography>
                                        </Grid>
                                        <Grid item md={3} sm={3} xs={6}>
                                        <Typography style={{ fontSize: '19px', fontWeight: '600' }}>Distance</Typography>
                                        <Typography style={{ fontSize: '17px' }}>{distance}</Typography>
                                        </Grid>
                                        <Grid item md={3} sm={3} xs={6}>
                                        {phoneNumber1 ? (
                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                    <span>{phoneNumber1}</span>
                                                </div>
                                            ) : (
                                                <Button
                                                    style={{
                                                        width: 'auto',
                                                        height: '51px',
                                                        fontSize: '18px',
                                                        fontWeight: 'bold',
                                                        backgroundColor: '#F3F6FB',
                                                        border: '1px solid #e2e5ea',
                                                        textTransform: 'capitalize',
                                                    }}
                                                    sx={{ fontFamily: 'inherit', }}
                                                    endIcon={<PhoneIcon />}
                                                    onClick={handleButtonViewNumber1}
                                                >
                                                    View Number
                                                </Button>
                                            )}
                                        </Grid>
                                    </Grid>
                                    <Grid container sx={{mt: '5px', p: '8px', backgroundColor: '#fff'}}>
                                        <Grid item md={3} sm={3} xs={6}>
                                        <Typography style={{ fontSize: '19px', fontWeight: '600', color: '#1976d2' }}>Agent</Typography>
                                        <Typography style={{ fontSize: '19px', color: '#000000CC' }}>{assigntoData?.name}{' '}{assigntoData?.last_name}</Typography>
                                        </Grid>
                                        <Grid item md={3} sm={3} xs={6}>
                                        <Typography style={{ fontSize: '19px', fontWeight: '600' }}>Duration</Typography>
                                                    <Typography style={{ fontSize: '17px' }}>{duration2}</Typography>
                                        </Grid>
                                        <Grid item md={3} sm={3} xs={6}>
                                        <Typography style={{ fontSize: '19px', fontWeight: '600' }}>Distance</Typography>
                                                    <Typography style={{ fontSize: '17px' }}>{distance2}</Typography>
                                        </Grid>
                                        <Grid item md={3} sm={3} xs={6}>
                                        {phoneNumber2 ? (
                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                    <span>{phoneNumber2}</span>
                                                </div>
                                            ) : (
                                                <Button
                                                    style={{
                                                        width: 'auto',
                                                        height: '51px',
                                                        fontSize: '18px',
                                                        fontWeight: 'bold',
                                                        backgroundColor: '#F3F6FB',
                                                        border: '1px solid #e2e5ea',
                                                        textTransform: 'capitalize',
                                                    }}
                                                    sx={{ fontFamily: 'inherit', }}
                                                    endIcon={<PhoneIcon />}
                                                    onClick={handleButtonViewNumber2}
                                                >
                                                    View Number
                                                </Button>
                                            )}
                                        </Grid>
                                    </Grid>
                                    <Grid container sx={{mt: '5px', p: '10px', backgroundColor: '#f3f3f3', borderRadius: '8px'}}>
                                        <Grid item xs={12}>
                                        <Typography style={{
                                                fontSize: '19px',
                                                fontWeight: '600',
                                            }}>Property Location</Typography>
                                            <Typography style={{ fontSize: '17px' }}>{jobData?.location}</Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid container sx={{mt: '5px', p: '10px', backgroundColor: '#fff', borderRadius: '8px'}}>
                                        <Grid item xs={12}>
                                        <Typography style={{
                                                    fontSize: '19px',
                                                    fontWeight: '600',
                                                }}>Meeting Location</Typography>
                                                <Typography style={{ fontSize: '17px' }}>{jobData?.meeting_location}</Typography>
                                        </Grid>
                                    </Grid>

                                    
                                   

                                </Card>

                                {/* Tracking */}
                                <Card style={{ padding: '20px', marginTop: '20px', borderRadius: '22px', boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px' }}>
                                    <Typography style={{ fontSize: '28px', fontWeight: '700' }}>Tracking</Typography>
                                    <Divider />

                                    <Box sx={{ display: 'flex', gap: '2px', overflow: 'auto',
                                        justifyContent: {
                                            xs: "normal",
                                            sm: "center",
                                            md: "center"
                                        },
                                     }}
                                    >
                                        <div>
                                            <Box style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
                                                <Box style={{ marginTop: '35px' }}>
                                                    <Typography style={{ fontSize: '18px', fontWeight: '700' }}>Customer</Typography>
                                                </Box>
                                                <Stack>
                                                    <FabContainer>
                                                        <Line />
                                                        <Line2 />
                                                        <ButtonContainer>
                                                            {distance && parseDistance(distance) <= 999 ? (
                                                                <Fab color="primary" aria-label="add">
                                                                    <CheckIcon />
                                                                </Fab>
                                                            ) : (
                                                                <Fab style={{ background: 'white' }}>
                                                                    <FiberManualRecordIcon style={{ fontSize: '12px', color: '#5379BD' }} />
                                                                </Fab>
                                                            )}

                                                            <ButtonLabel>1000M</ButtonLabel>
                                                        </ButtonContainer>

                                                        <ButtonContainer>
                                                            {distance && parseDistance(distance) <= 499 ? (
                                                                <Fab color="primary" aria-label="add">
                                                                    <CheckIcon />
                                                                </Fab>
                                                            ) : (
                                                                <Fab style={{ background: 'white' }}>
                                                                    <FiberManualRecordIcon style={{ fontSize: '12px', color: '#5379BD' }} />
                                                                </Fab>
                                                            )}
                                                            <ButtonLabel>500M</ButtonLabel>
                                                        </ButtonContainer>


                                                        <ButtonContainer>
                                                            {distance && parseDistance(distance) <= 99 ? (
                                                                <Fab color="primary" aria-label="add">
                                                                    <CheckIcon />
                                                                </Fab>
                                                            ) : (
                                                                <Fab style={{ background: 'white' }}>
                                                                    <FiberManualRecordIcon style={{ fontSize: '12px', color: '#5379BD' }} />
                                                                </Fab>
                                                            )}
                                                            <ButtonLabel>100M</ButtonLabel>
                                                        </ButtonContainer>
                                                    </FabContainer>
                                                </Stack>
                                            </Box>

                                            <Box style={{ display: 'flex', justifyContent: 'center', marginTop: '15px', gap: '40px' }}>
                                                <Box style={{ marginTop: '35px' }}>
                                                    <Typography style={{ fontSize: '18px', fontWeight: '700' }}>Agent</Typography>
                                                </Box>
                                                <Stack>
                                                    <FabContainer>
                                                        <Line />
                                                        <Line2 />
                                                        <ButtonContainer>
                                                            {distance2 && parseDistance(distance2) <= 999 ? (
                                                                <Fab color="primary" aria-label="add">
                                                                    <CheckIcon />
                                                                </Fab>
                                                            ) : (
                                                                <Fab style={{ background: 'white' }}>
                                                                    <FiberManualRecordIcon style={{ fontSize: '12px', color: '#5379BD' }} />
                                                                </Fab>
                                                            )}

                                                            <ButtonLabel>1000M</ButtonLabel>
                                                        </ButtonContainer>

                                                        <ButtonContainer>
                                                            {distance2 && parseDistance(distance2) <= 499 ? (
                                                                <Fab color="primary" aria-label="add">
                                                                    <CheckIcon />
                                                                </Fab>
                                                            ) : (
                                                                <Fab style={{ background: 'white' }}>
                                                                    <FiberManualRecordIcon style={{ fontSize: '12px', color: '#5379BD' }} />
                                                                </Fab>
                                                            )}
                                                            <ButtonLabel>500M</ButtonLabel>
                                                        </ButtonContainer>


                                                        <ButtonContainer>
                                                            {distance2 && parseDistance(distance2) <= 99 ? (
                                                                <Fab color="primary" aria-label="add">
                                                                    <CheckIcon />
                                                                </Fab>
                                                            ) : (
                                                                <Fab style={{ background: 'white' }}>
                                                                    <FiberManualRecordIcon style={{ fontSize: '12px', color: '#5379BD' }} />
                                                                </Fab>
                                                            )}
                                                            <ButtonLabel>100M</ButtonLabel>
                                                        </ButtonContainer>
                                                    </FabContainer>
                                                </Stack>
                                            </Box>
                                        </div>
                                        <div style={{ display: "flex" }}>
                                            <div>
                                                <Box style={{ marginTop: '80px' }}>
                                                    <Divider style={{ color: 'red', border: '1px solid #B4B4B4', width: '120px', rotate: '30deg' }} />
                                                </Box>
                                                <Box style={{ marginTop: '60px' }}>
                                                    <Divider style={{ color: 'red', border: '1px solid #B4B4B4', width: '119px', rotate: '-30deg' }} />
                                                </Box>
                                            </div>

                                            <div style={{ marginTop: '35px' }}>
                                                <img src={PropertyIcon} alt="" style={{ width: '120px', height: '123px' }} />
                                                <Typography style={{ fontSize: '28px', fontWeight: '700' }}>Property</Typography>
                                            </div>
                                        </div>
                                    </Box>



                                </Card>

                                {/*  */}

                                {/* <Card style={{ padding: '20px', marginTop: '10px',borderRadius:'22px', boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px' }}>
                        <Typography style={{ fontSize: '28px', fontWeight: '700' }}>Feedback & Reviews</Typography>
                        <Divider />

                        <Box style={{ marginTop: '20px' }}>
                            <Divider />
                        </Box>

                        <div style={{ display: 'flex', marginTop: '20px', padding: '20px', gap: '20px' }}>

                            <div>
                                <Box style={{ display: 'flex', justifyContent: 'space-between', }}>

                                    <Box style={{ display: 'flex', gap: '20px' }}>
                                        <div>
                                            <Avatar />
                                        </div>
                                        <div style={{ display: 'grid' }}>
                                            <Typography style={{ fontSize: '20px', fontWeight: '500', color: '#202020' }}>Lucy Hernandez</Typography>
                                            <Typography style={{ fontSize: '17px', color: '#7E7E7E' }}>Agent</Typography>
                                        </div>

                                    </Box>

                                    <Box>
                                        <Rating name="disabled" value={value} style={{ color: '#5379BD' }} />
                                    </Box>
                                </Box>

                                <Box style={{ marginTop: '15px' }}>
                                    <Typography style={{ fontSize: '17px', color: '#5F5F5F', textAlign: 'justify' }}>
                                        Iconnect stands out as a paradigm of excellence in the realm of real estate websites.
                                        Its user-friendly interface simplifies property searches, while personalized recommendations
                                        streamline the process by tailoring options to individual preferences.
                                    </Typography>
                                </Box>
                            </div>

                            <div>
                                <Box style={{ display: 'flex', justifyContent: 'space-between', }}>

                                    <Box style={{ display: 'flex', gap: '20px' }}>
                                        <div>
                                            <Avatar />
                                        </div>
                                        <div style={{ display: 'grid' }}>
                                            <Typography style={{ fontSize: '20px', fontWeight: '500', color: '#202020' }}>Lucy Hernandez</Typography>
                                            <Typography style={{ fontSize: '17px', color: '#7E7E7E' }}>Agent</Typography>
                                        </div>

                                    </Box>

                                    <Box>
                                        <Rating name="disabled" value={value} style={{ color: '#5379BD' }} />
                                    </Box>
                                </Box>

                                <Box style={{ marginTop: '15px' }}>
                                    <Typography style={{ fontSize: '17px', color: '#5F5F5F', textAlign: 'justify' }}>
                                        Iconnect stands out as a paradigm of excellence in the realm of real estate websites.
                                        Its user-friendly interface simplifies property searches, while personalized recommendations
                                        streamline the process by tailoring options to individual preferences.
                                    </Typography>
                                </Box>
                            </div>
                        </div>
                    </Card> */}
                            </ScrollAnimation>

                        </Box>
                    ) : (
                        // Render "No job detail found" message
                        <Typography variant="h6" style={{ textAlign: 'center' }}>
                            No job detail found
                        </Typography>
                    )}
                </Box>
            </ThemeProvider>
        </>
    ) : (
        <>

        </>
    )
}
export default AdminJobDetails
